// http://router.vuejs.org/en/
import Vue from 'vue'
import VueRouter from 'vue-router'

import CONFIG from '../../config'

Vue.use(VueRouter)

const routes = []

Object.keys(CONFIG.pages).forEach(key => {
    routes.push(Object.assign({}, CONFIG.pages[key]))
})

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router



// WEBPACK FOOTER //
// ./src/scripts/application/Router.js